import { styled } from 'styled-components';

export const SkeletonHeaderItem = styled.div`
  width: 220px;
  align-self: center;
`;

export const BonusItemSkeletonCard = styled.div`
  width: 100%;
  aspect-ratio: 364 / 220;
  overflow: hidden;
  border-radius: 8px;

  @media (max-width: 768px) {
    aspect-ratio: 343 / 150;
  }
`;
